import type { Work } from "@/types/content";

export const works: Work[] = [
  {
    id: "w-01",
    title: "海边来信",
    type: "movie",
    year: 2019,
    genre: "剧情 / 文艺",
    tags: ["海边", "书信", "成长"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20still%20of%20an%20empty%20seaside%20railway%20platform%20at%20dusk%2C%20muted%20deep%20navy%20sky%20with%20warm%20amber%20lantern%20glow%2C%20soft%20film%20grain%2C%20atmospheric%20fog%2C%20artistic%20minimal%20composition%2C%20no%20people%2C%20high%20detail%2C%20vertical%20framing&width=600&height=800&seq=cover-01&orientation=portrait",
    rating: 7.9,
    runtime: "118 分钟",
    director: "森田和也",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 林梓", note: "片中饰演回到海边小城整理旧居的编辑，全片以大量静默镜头呈现人物内心。" },
      { name: "高野真央", role: "饰 佐藤遥", note: "邮局职员，是林梓少年时代的笔友。" },
      { name: "中原理沙", role: "饰 林梓母亲", note: "以少量回忆片段出现，串起两代人的选择。" },
    ],
    synopsis: [
      "在城市生活了十年的林梓，因为一封被退回的旧信回到海边小城。她原本只打算停留三天，却在整理母亲旧居的过程中，重新读到少年时代与笔友往来的三十七封信。",
      "潮水每天按时退去，信件里的约定却始终没有兑现。影片用克制的对白和大量环境声，讲述一个人如何与过去和解，也讲述一座小城如何在旅游业兴起后慢慢改变模样。",
    ],
    highlight: "第 32 届亚洲电影展 最佳摄影提名",
  },
  {
    id: "w-02",
    title: "白色回声",
    type: "movie",
    year: 2017,
    genre: "悬疑 / 剧情",
    tags: ["悬疑", "心理", "雨夜"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Moonlit%20cinematic%20still%20of%20a%20foggy%20white%20corridor%20with%20a%20single%20open%20door%2C%20cold%20navy%20shadows%20and%20warm%20amber%20light%20spill%2C%20heavy%20film%20grain%2C%20suspense%20atmosphere%2C%20no%20people%2C%20minimal%20vertical%20composition&width=600&height=800&seq=cover-02&orientation=portrait",
    rating: 7.4,
    runtime: "106 分钟",
    director: "浅井淳",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 白石音", note: "饰演听觉异常敏锐的录音师，是整部影片的視角人物。" },
      { name: "冈田健吾", role: "饰 刑警 三浦", note: "负责调查旧医院失踪案。" },
      { name: "藤井千夏", role: "饰 护士 长谷川", note: "唯一留在旧医院的夜班人员。" },
    ],
    synopsis: [
      "一间废弃医院在拆迁前夜传出奇怪的声音。录音师白石音受邀前往采集环境音，却在回放素材时听到了一段不属于当下的对话。",
      "声音成为唯一的线索。她顺着走廊里的回声层层追查，发现十七年前的一场事故并没有随着建筑一起被封存。",
    ],
    highlight: "全片 70% 声音素材为现场实录",
  },
  {
    id: "w-03",
    title: "夜色列车",
    type: "movie",
    year: 2020,
    genre: "爱情 / 剧情",
    tags: ["列车", "重逢", "都市"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20train%20window%20glowing%20warm%20amber%20in%20deep%20blue%20darkness%2C%20rain%20streaks%20on%20glass%2C%20cinematic%20film%20still%2C%20soft%20bokeh%20lights%2C%20moody%20and%20quiet%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-03&orientation=portrait",
    rating: 7.6,
    runtime: "112 分钟",
    director: "森田和也",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 佐仓澪", note: "往返于两座城市之间的通勤者。" },
      { name: "北村涼", role: "饰 三谷", note: "在同一节车厢里出现七年的陌生人。" },
      { name: "小林纱英", role: "饰 澪的妹妹", note: "以电话声音贯穿全片。" },
    ],
    synopsis: [
      "每周五晚十一点，最后一班列车上总有两个人坐在同一节车厢。他们从不交谈，只是各自看着窗外。",
      "一次临时停车让沉默被打破。两个在白天过着完全不同生活的人，在夜色里交换了一段只有列车知道的故事。",
    ],
    highlight: "实景拍摄于山手线末班车时段",
  },
  {
    id: "w-04",
    title: "夏日终章",
    type: "movie",
    year: 2016,
    genre: "剧情 / 青春",
    tags: ["夏天", "校园", "告别"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Sunlit%20empty%20classroom%20in%20late%20summer%20afternoon%2C%20warm%20amber%20light%20through%20window%20blinds%2C%20dust%20in%20the%20air%2C%20nostalgic%20cinematic%20film%20still%2C%20deep%20blue%20shadows%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-04&orientation=portrait",
    rating: 8.1,
    runtime: "124 分钟",
    director: "河合直树",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 松本夏织", note: "文学部三年级学生，毕业前最后一个夏天。" },
      { name: "石田悠", role: "饰 前辈 汤川", note: "即将离校的摄影社社长。" },
      { name: "森川葵", role: "饰 室友 小野", note: "全片的情绪调和者。" },
    ],
    synopsis: [
      "毕业前的最后一个夏天，文学部的松本夏织接到任务：为即将拆除的旧校舍写一篇纪念文章。",
      "她在资料室里翻到一本没有署名的毕业文集，里面的句子像是写给十年后的某个人。追寻作者的过程中，她第一次认真思考告别这件事。",
    ],
    highlight: "日本电影学院奖 最佳新人提名",
  },
  {
    id: "w-05",
    title: "逆光之夏",
    type: "movie",
    year: 2021,
    genre: "剧情 / 家庭",
    tags: ["海边", "家庭", "治愈"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Bicycle%20leaning%20against%20a%20coastal%20road%20railing%2C%20strong%20backlight%20warm%20orange%20horizon%20over%20navy%20sea%2C%20cinematic%20film%20still%2C%20soft%20grain%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-05&orientation=portrait",
    rating: 7.7,
    runtime: "115 分钟",
    director: "高梨知沙",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 佐野千寻", note: "辞职回家照顾父亲的女儿。" },
      { name: "大杉涟", role: "饰 父亲 佐野修", note: "退休船长，固执而沉默。" },
      { name: "滨田优", role: "饰 弟弟 佐野海", note: "在渔港工作的弟弟。" },
    ],
    synopsis: [
      "千寻辞掉东京的工作回到海边老家，父亲却把她当作客人。父女两人在同一屋檐下，用一整个夏天才学会正常说话。",
      "逆光里的海面很亮，亮到看不清对方的表情。影片用三餐、修船和潮汐表，慢慢拼出一个家庭的裂缝与修补。",
    ],
    highlight: "入选东京国际影视周「日本电影人」单元",
  },
  {
    id: "w-06",
    title: "雨巷十七号",
    type: "movie",
    year: 2018,
    genre: "悬疑 / 犯罪",
    tags: ["雨夜", "推理", "旧城"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Rain%20soaked%20narrow%20alley%20at%20night%20with%20wet%20cobblestones%20reflecting%20warm%20amber%20street%20lamp%2C%20deep%20navy%20shadows%2C%20cinematic%20mystery%20film%20still%2C%20film%20grain%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-06&orientation=portrait",
    rating: 7.3,
    runtime: "110 分钟",
    director: "浅井淳",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 记者 宫濑", note: "追踪旧城改造报道的周刊记者。" },
      { name: "远藤宪一", role: "饰 老店主", note: "十七号门牌下唯一的住户。" },
      { name: "樱井由纪", role: "饰 档案管理员", note: "提供关键旧报纸。" },
    ],
    synopsis: [
      "旧城区改造前，十七号的门牌被悄悄换掉了。记者宫濑在整理旧报纸时发现，这条雨巷在过去二十年里换过四次门牌。",
      "每一块门牌背后都对应着一起没有被记录的纠纷。雨水冲刷着石阶，也冲出了被刻意抹去的名字。",
    ],
    highlight: "拍摄期连续 21 天使用真实降雨场景",
  },
  {
    id: "w-07",
    title: "风起之时",
    type: "movie",
    year: 2022,
    genre: "剧情 / 文艺",
    tags: ["乡野", "季节", "离别"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Wind%20blowing%20through%20tall%20grass%20field%20under%20dramatic%20deep%20blue%20sky%2C%20warm%20amber%20sunset%20edge%2C%20cinematic%20wide%20angle%20film%20still%2C%20soft%20grain%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-07&orientation=portrait",
    rating: 7.8,
    runtime: "108 分钟",
    director: "高梨知沙",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 农协职员 早川", note: "负责记录休耕土地的女性职员。" },
      { name: "柄本明", role: "饰 老农 佐久间", note: "坚持耕种最后一块田的老人。" },
      { name: "松冈茉优", role: "饰 返乡青年 由纪", note: "想把农田改成露营地的年轻人。" },
    ],
    synopsis: [
      "早川的工作是统计休耕土地。她带着一张地图走遍乡野，把一块块不再种田的土地标记成空白。",
      "老农佐久间拒绝签字，他的那块田成了地图上唯一的例外。风起的时候，稻穗和野草的方向不一样，人的选择也是。",
    ],
    highlight: "全片采用 16mm 胶片拍摄",
  },
  {
    id: "w-08",
    title: "无声告白",
    type: "movie",
    year: 2015,
    genre: "剧情 / 家庭",
    tags: ["家庭", "亲情", "治愈"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20hospital%20window%20with%20sheer%20curtain%20and%20warm%20afternoon%20light%2C%20desaturated%20navy%20and%20amber%20palette%2C%20cinematic%20film%20still%2C%20tender%20minimal%20mood%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-08&orientation=portrait",
    rating: 8.2,
    runtime: "121 分钟",
    director: "河合直树",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 长女 三宅纱织", note: "在医院与公司之间往返的姐姐。" },
      { name: "风吹淳", role: "饰 母亲 三宅和子", note: "因病失去部分语言能力的母亲。" },
      { name: "坂口健太郎", role: "饰 弟弟 三宅亮", note: "长期在外地工作的弟弟。" },
    ],
    synopsis: [
      "母亲病后说话变得困难，三宅家的姐弟俩开始用便签和短信代替交谈。家里变得很安静，安静到每个人都听见了自己的心事。",
      "纱织在整理母亲的抽屉时发现一叠没有寄出的信，收件人是三个孩子。她第一次知道，母亲一直在用自己的方式说话。",
    ],
    highlight: "第 39 届日本电影学院奖 优秀作品",
  },
  {
    id: "w-09",
    title: "远山的灯火",
    type: "movie",
    year: 2023,
    genre: "家庭 / 剧情",
    tags: ["山村", "亲情", "归乡"],
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Distant%20mountain%20village%20lights%20glowing%20warm%20amber%20at%20blue%20hour%2C%20misty%20layered%20ridge%20lines%2C%20cinematic%20film%20still%2C%20calm%20and%20nostalgic%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-09&orientation=portrait",
    rating: 8.4,
    runtime: "126 分钟",
    director: "高梨知沙",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 高桥奈绪", note: "在城市做建筑设计的女儿，因父亲病重返乡。" },
      { name: "仲代达矢", role: "饰 父亲 高桥源", note: "在山村守了四十年小学教室的老人。" },
      { name: "上白石萌音", role: "饰 村教师 小春", note: "最后一届学生只有两人的年轻教师。" },
    ],
    synopsis: [
      "一所只有两名学生的小学即将关闭。奈绪回到山村，为父亲守了四十年的教室做最后的测量。",
      "山里的灯一盏一盏熄灭，父亲却坚持每天傍晚打开校门的灯。他说只要灯亮着，走夜路的人就不会迷路。",
    ],
    highlight: "第 36 届亚洲电影展 主竞赛单元入围",
  },
  {
    id: "w-10",
    title: "最后的放映",
    type: "movie",
    year: 2024,
    genre: "剧情 / 文艺",
    tags: ["电影院", "记忆", "告别"],
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20cinema%20projection%20beam%20cutting%20through%20dusty%20dark%20hall%2C%20warm%20amber%20light%20and%20deep%20navy%20shadows%2C%20cinematic%20film%20still%2C%20grain%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-10&orientation=portrait",
    rating: 8.0,
    runtime: "114 分钟",
    director: "森田和也",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 放映员 岩井遥", note: "老电影院最后一位放映员。" },
      { name: "山崎努", role: "饰 老板 大庭", note: "经营影院五十年的老人。" },
      { name: "吉冈里帆", role: "饰 常客 千夏", note: "每周三固定来看老片的观众。" },
    ],
    synopsis: [
      "老电影院将在月底停业，放映员岩井遥决定在最后一周，把仓库里所有没来得及上映的胶片放一遍。",
      "来看的人从三个变成三十个。最后一场没有排片表，只有一块手写的小黑板。灯暗下来的时候，所有人都知道这是最后一次。",
    ],
    highlight: "2024 年度日本电影十佳 第 6 位",
  },
  {
    id: "w-11",
    title: "东京旧梦",
    type: "tv",
    year: 2018,
    genre: "都市 / 剧情",
    tags: ["都市", "职场", "旧城"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20Tokyo%20backstreet%20at%20night%2C%20warm%20amber%20shop%20signs%20reflecting%20on%20wet%20pavement%2C%20deep%20navy%20sky%2C%20cinematic%20film%20still%2C%20nostalgic%20mood%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-11&orientation=portrait",
    rating: 7.5,
    runtime: "全 10 集 / 单集 45 分钟",
    director: "三木孝浩",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 神谷玲", note: "在老街区经营小印刷厂的第二代。" },
      { name: "瑛太", role: "饰 建筑师 桐生", note: "负责街区再开发项目的设计师。" },
      { name: "田中裕子", role: "饰 房东 花井", note: "整条街最年长的住户。" },
    ],
    synopsis: [
      "东京老街区被列入再开发计划，印刷厂的订单一天比一天少。神谷玲一边维持父亲的旧机器，一边面对不断上门的收购提案。",
      "建筑师桐生带着图纸出现，他想要保留街道的纹理，却发现自己的方案和公司的计划并不一致。十集故事，讲的是一条街如何记住自己。",
    ],
    highlight: "第 12 回 东京电视剧赏 优秀作品赏",
  },
  {
    id: "w-12",
    title: "春日杂货铺",
    type: "tv",
    year: 2020,
    genre: "温情 / 生活",
    tags: ["治愈", "小店", "日常"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20small%20grocery%20shop%20front%20with%20warm%20amber%20lights%20and%20potted%20plants%20in%20spring%2C%20soft%20daylight%2C%20cinematic%20film%20still%2C%20gentle%20navy%20shadows%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-12&orientation=portrait",
    rating: 8.3,
    runtime: "全 12 集 / 单集 30 分钟",
    director: "平野真",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 店主 春野", note: "接手外婆杂货铺的年轻店主。" },
      { name: "小林聪美", role: "饰 常客 冈田太太", note: "每天来买一份报纸。" },
      { name: "中川雅也", role: "饰 送货员 阿部", note: "负责整条街的配送。" },
    ],
    synopsis: [
      "春野辞职回到小镇，接手外婆留下的杂货铺。货架上还留着三十年前的价签，记账本写到一半。",
      "每一集有一位客人和一件小小的委托：一包找不到的糖、一只旧饭盒、一张没有寄出的明信片。日子很慢，但每件事都有回应。",
    ],
    highlight: "豆瓣年度日剧榜前十",
  },
  {
    id: "w-13",
    title: "深夜食堂物语",
    type: "tv",
    year: 2019,
    genre: "美食 / 治愈",
    tags: ["深夜", "食堂", "人情"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Late%20night%20small%20diner%20counter%20with%20warm%20amber%20hanging%20lamps%2C%20steam%20rising%2C%20deep%20navy%20darkness%20outside%20window%2C%20cinematic%20film%20still%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-13&orientation=portrait",
    rating: 7.9,
    runtime: "全 10 集 / 单集 28 分钟",
    director: "松冈锭司",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 店主之女 美咲", note: "接手深夜食堂的第二代掌勺人。" },
      { name: "小林薰", role: "饰 老店主", note: "退休后仍坐在角落喝一杯。" },
      { name: "光石研", role: "饰 出租车司机 佐伯", note: "每晚两点准时出现。" },
    ],
    synopsis: [
      "深夜十二点开门，清晨七点关门。菜单上只有八道菜，但客人想吃什么都可以点。",
      "美咲接手食堂的第一年，遇到了十个不同的夜晚：加班的、失恋的、准备离开这座城市的。一碗热汤解决不了什么，但能让人坐下来。",
    ],
    highlight: "深夜档收视连续六周同时段第一",
  },
  {
    id: "w-14",
    title: "潮汐之间",
    type: "tv",
    year: 2021,
    genre: "悬疑 / 剧情",
    tags: ["海岛", "悬疑", "记忆"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20tidal%20flat%20at%20dawn%20with%20rippling%20shallow%20water%20reflecting%20cool%20navy%20sky%20and%20faint%20amber%20glow%2C%20cinematic%20atmospheric%20film%20still%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-14&orientation=portrait",
    rating: 8.0,
    runtime: "全 8 集 / 单集 52 分钟",
    director: "浅井淳",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 气象观测员 真壁潮", note: "驻岛三年的观测员，也是案件的关键证人。" },
      { name: "阿部宽", role: "饰 刑警 岛田", note: "从本土调来的调查负责人。" },
      { name: "满岛光", role: "饰 岛医 由比", note: "岛上唯一的医生。" },
    ],
    synopsis: [
      "涨潮时露出的小路，退潮后消失。一座只有四百人的岛上，每年都有人在同一片滩涂失踪。",
      "气象观测员真壁潮记录了十年潮汐数据，她发现所有失踪都发生在同一个潮位。刑警岛田带着旧案卷登岛，两人在潮起潮落之间拼出真相。",
    ],
    highlight: "第 58 届银河赏 电视部门 鼓励赏",
  },
  {
    id: "w-15",
    title: "第七个春天",
    type: "tv",
    year: 2022,
    genre: "爱情 / 剧情",
    tags: ["爱情", "重逢", "时间"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Cherry%20blossom%20branches%20against%20soft%20evening%20sky%2C%20warm%20amber%20lantern%20glow%2C%20cinematic%20romantic%20film%20still%2C%20film%20grain%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-15&orientation=portrait",
    rating: 7.6,
    runtime: "全 11 集 / 单集 46 分钟",
    director: "三木孝浩",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 书店店员 水野栞", note: "每年春天都回到同一家书店。" },
      { name: "佐藤健", role: "饰 摄影师 大河", note: "七年前在樱花树下错过的人。" },
      { name: "药师丸博子", role: "饰 书店老板娘", note: "见证了所有人的春天。" },
    ],
    synopsis: [
      "七年前的春天，水野栞和大河约在樱花树下见面，两个人都没有出现。",
      "七年后的同一天，他们在同一家书店的同一排书架前再次相遇。剧本用七个春天，讲述两个人如何一次次靠近又退开。",
    ],
    highlight: "年度话题日剧 微博热搜累计在榜 42 小时",
  },
  {
    id: "w-16",
    title: "山手线以南",
    type: "tv",
    year: 2017,
    genre: "都市 / 群像",
    tags: ["都市", "群像", "通勤"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20subway%20platform%20with%20cool%20navy%20fluorescent%20light%20and%20warm%20amber%20exit%20sign%2C%20cinematic%20urban%20film%20still%2C%20strong%20leading%20lines%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-16&orientation=portrait",
    rating: 7.4,
    runtime: "全 10 集 / 单集 42 分钟",
    director: "平野真",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 站务员 佐仓", note: "在山手线南段小站工作七年。" },
      { name: "松田龙平", role: "饰 通勤者 神野", note: "每天在同一时间经过检票口。" },
      { name: "安藤樱", role: "饰 便利店店员 由佳", note: "站前便利店夜班。" },
    ],
    synopsis: [
      "一个只有两个出口的小站，每天有六万人经过。站务员佐仓记得其中二十几个人的脸，却不知道他们的名字。",
      "十集故事围绕这个车站展开：错过末班车的人、在站台告白的人、把行李寄存在储物柜里三年的人。城市很大，故事都发生在很小的地点。",
    ],
    highlight: "第 9 回 东京电视剧赏 主演赏 提名",
  },
  {
    id: "w-17",
    title: "漫长的告白",
    type: "tv",
    year: 2023,
    genre: "家庭 / 剧情",
    tags: ["家庭", "亲情", "时间"],
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20wooden%20dining%20table%20by%20a%20window%20with%20warm%20afternoon%20sunlight%2C%20faded%20family%20photo%20frame%2C%20cinematic%20film%20still%2C%20navy%20shadows%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-17&orientation=portrait",
    rating: 8.5,
    runtime: "全 12 集 / 单集 48 分钟",
    director: "河合直树",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 二女儿 森下奈月", note: "整理母亲遗物时发现一段录音。" },
      { name: "倍赏千惠子", role: "饰 母亲 森下千代", note: "以录音和回忆的形式贯穿全剧。" },
      { name: "妻夫木聪", role: "饰 大哥 森下诚", note: "长子，负责处理房产。" },
    ],
    synopsis: [
      "母亲去世后，三兄妹在老房子里整理遗物，找到一箱标着年份的录音带。从他们出生那年开始，一年一盘，从未间断。",
      "录音里有天气、菜价、谁又长高了，也有一些从来没有说出口的话。三兄妹用十二集的时间，听完了一场长达三十年的告白。",
    ],
    highlight: "2023 年度豆瓣评分最高日剧 第 3 位",
  },
  {
    id: "w-18",
    title: "光的方向",
    type: "tv",
    year: 2024,
    genre: "剧情 / 社会",
    tags: ["职场", "成长", "社会"],
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Long%20corridor%20with%20strong%20warm%20amber%20light%20at%20the%20far%20end%20against%20deep%20navy%20walls%2C%20cinematic%20dramatic%20film%20still%2C%20minimal%20composition%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-18&orientation=portrait",
    rating: 8.1,
    runtime: "全 10 集 / 单集 50 分钟",
    director: "西谷弘",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 辩护律师 桐野光", note: "接手法律援助案件的年轻律师。" },
      { name: "堺雅人", role: "饰 前辈律师 真锅", note: "事务所里最难相处的合伙人。" },
      { name: "黑木华", role: "饰 当事人 田村", note: "第一集的委托人，贯穿全剧的回访线索。" },
    ],
    synopsis: [
      "桐野光从大事务所转到法律援助中心，第一个案子是为一名被解雇的工厂女工争取赔偿。",
      "案件很小，牵出的问题却很大。十集故事里，她处理的每一个案子都指向同一个问题：规则保护的是谁。",
    ],
    highlight: "2024 年秋季档 收视与口碑双冠",
  },
  {
    id: "w-19",
    title: "记忆收藏家",
    type: "tv",
    year: 2021,
    genre: "奇幻 / 剧情",
    tags: ["奇幻", "记忆", "治愈"],
    status: "classic",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20archive%20shelves%20with%20dust%20in%20a%20shaft%20of%20warm%20amber%20light%2C%20deep%20navy%20shadows%2C%20cinematic%20mysterious%20film%20still%2C%20film%20grain%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-19&orientation=portrait",
    rating: 7.7,
    runtime: "全 9 集 / 单集 44 分钟",
    director: "三木孝浩",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 收藏家 白石", note: "替人保管无法承受的记忆。" },
      { name: "井浦新", role: "饰 助手 叶山", note: "负责登记每一段记忆。" },
      { name: "门胁麦", role: "饰 客人 早苗", note: "想寄存一段夏天的记忆。" },
    ],
    synopsis: [
      "在城市尽头有一间没有招牌的档案室，替人保管那些不想再想起的记忆。收藏家白石每天整理标签，从不打开盒子。",
      "一位客人寄存了一段夏天的记忆，却在第二天要求取回。白石第一次打破规矩，也因此想起了自己寄存的那一段。",
    ],
    highlight: "第 45 回 放送文化基金赏 电视剧部门 优秀赏",
  },
  {
    id: "w-20",
    title: "海边书店",
    type: "tv",
    year: 2026,
    genre: "治愈 / 生活",
    tags: ["新作", "海边", "书店"],
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20seaside%20bookstore%20window%20glowing%20warm%20amber%20at%20blue%20hour%2C%20wooden%20shelves%20and%20books%20visible%20inside%2C%20cinematic%20film%20still%2C%20navy%20sea%20horizon%2C%20no%20people%2C%20vertical%20composition&width=600&height=800&seq=cover-20&orientation=portrait",
    rating: 0,
    runtime: "全 10 集 / 单集 45 分钟（待播）",
    director: "高梨知沙",
    region: "日本",
    language: "日语",
    cast: [
      { name: "大桥未久", role: "饰 店主 里见栞", note: "回到海边接手旧书店的女性。" },
      { name: "中村伦也", role: "饰 常客 佐野", note: "每周来换一本书的渔夫。" },
      { name: "岸井雪乃", role: "饰 编辑 宫下", note: "从东京来谈出版合作。" },
    ],
    synopsis: [
      "海边小镇唯一的书店即将关门。里见栞在整理库存时，发现一本被反复借阅却从未归还的书，借书卡上只有一个名字。",
      "她决定在关店前找到这位读者。新作预计 2027 年春季播出，首支预告已于本月公开。",
    ],
    highlight: "2026 年最受期待新剧 TOP 5",
  },
];

export const movies = works.filter((item) => item.type === "movie");

export const tvShows = works.filter((item) => item.type === "tv");